import React, { ChangeEvent } from 'react';
import { Box, TextField, Button } from '@mui/material';
import { ValidationUtils } from '../../utils/validationutils';

interface UserDetailsFormProps {
  userDetails: { firstName: string; lastName: string; studentCode: string };
  setUserDetails: React.Dispatch<
    React.SetStateAction<{ firstName: string; lastName: string; studentCode: string }>
  >;
  handleVerifyCode: () => void;
}

const UserDetailsForm: React.FC<UserDetailsFormProps> = ({
  userDetails,
  setUserDetails,
  handleVerifyCode,
}) => {
  const handleChange = (field: string) => (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    // Validate input based on the field
    const validatedValue =
      field === 'firstName' || field === 'lastName'
        ? ValidationUtils.validateNameInput(value) // Validate names
        : field === 'studentCode'
          ? ValidationUtils.validateCodeInput(value) // Validate codes
          : value;

    setUserDetails((prev) => ({ ...prev, [field]: validatedValue }));
  };

  // Check if all fields are filled
  const isVerifyDisabled =
    !userDetails.firstName || !userDetails.lastName || !userDetails.studentCode;

  return (
    <Box>
      {/* First Name */}
      <Box mb={2}>
        <TextField
          fullWidth
          label="Student First Name"
          variant="outlined"
          value={userDetails.firstName}
          onChange={handleChange('firstName')}
          slotProps={{
            inputLabel: {
              required: true,
            },
          }}

        />
      </Box>

      {/* Last Name */}
      <Box mb={2}>
        <TextField
          fullWidth
          label="Student Last Name"
          variant="outlined"
          value={userDetails.lastName}
          onChange={handleChange('lastName')}
          slotProps={{
            inputLabel: {
              required: true,
            },
          }}
        />
      </Box>

      {/* Claim Code */}
      <Box mb={2}>
        <TextField
          fullWidth
          label="Student Code"
          variant="outlined"
          value={userDetails.studentCode}
          onChange={handleChange('studentCode')}
          slotProps={{
            inputLabel: {
              required: true,
            },
          }}
        />
      </Box>
      <div className='note'>Note : * Mandatory fields to be filled</div>

      {/* Verify Code Button */}
      <Box>
        <Button
          aria-label="Verify Student Code"
          variant="contained"
          color="primary"
          onClick={handleVerifyCode}
          disabled={isVerifyDisabled} // Disable the button if any field is empty
          sx={{ mt: 1 }}
        >
          Verify Student Code
        </Button>
      </Box>
    </Box>
  );
};

export default UserDetailsForm;
